"use client";

import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StillNeedHelp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="231997" id="ready-to-upskill" className="dark bg-background py-20 px-4">
      <div className="max-w-2xl mx-auto flex items-center justify-center">
        <div ref={ref} className={`
            w-full text-center px-10 py-14 rounded-3xl
            border border-white/10 backdrop-blur-xl
            transition-all duration-700 ease-out
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `} style={{
        background: "linear-gradient(135deg, hsl(222 47% 15% / 0.8), hsl(245 100% 60% / 0.1))"
      }}>
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg mb-6 shadow-lg shadow-primary/20" style={{
          background: "var(--secondary)"
        }}>
            <MessageCircle className="w-5 h-5" style={{
            color: "var(--secondary-foreground)"
          }} />
          </div>

          <h2 className="font-default text-2xl md:text-3xl font-bold mb-3 leading-snug tracking-tight" style={{
          color: "var(--foreground)"
        }}>
            Ready to scale your business operations?
          </h2>

          <p className="font-default text-base mb-8 max-w-md mx-auto leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>
            Consult with our BPO experts to design a custom training or outsourcing strategy for your team.
          </p>

          <Button asChild size="lg" className="rounded-md px-8 py-3 font-default font-bold text-base shadow-md transition-all hover:shadow-xl hover:scale-105 bg-primary text-primary-foreground border border-white/10" style={{
          background: "var(--primary)",
          color: "var(--primary-foreground)"
        }}>
            <Link to="/GetInTouchPage">Get in Touch</Link>
          </Button>
        </div>
      </div>
    </section>;
}